module.exports = __webpack_public_path__ + "explosion.mp3?b1c69e868b7f4aab29abc63dd6762946";


//////////////////
// WEBPACK FOOTER
// ./src/kits/1/sounds/explosion.mp3
// module id = 479
// module chunks = 0